import { ReviewConnectionQuery } from '../queries';
import { useQuery, OperationVariables } from '@apollo/client';
import { ReviewData } from '@reviewshake-app/shake-ui';

type UseReviewConnection = {
  reviews: Array<ReviewData>;
  onLoadMore: () => void;
  loading: boolean;
};

const useReviewConnection = (variables?: OperationVariables): UseReviewConnection => {
  const { data, fetchMore, loading } = useQuery(ReviewConnectionQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  const onLoadMore = () =>
    data?.reviewWidget.reviewConnection.pageInfo.hasNextPage &&
    fetchMore({
      variables: {
        cursor: data.reviewWidget.reviewConnection.pageInfo.endCursor,
        token: variables.token,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newNodes = fetchMoreResult.reviewWidget.reviewConnection.nodes || [];
        const pageInfo = fetchMoreResult.reviewWidget.reviewConnection.pageInfo;

        return newNodes.length
          ? {
              ...fetchMoreResult,
              reviewWidget: {
                ...fetchMoreResult.reviewWidget,
                reviewConnection: {
                  __typename: previousResult.reviewWidget.reviewConnection.__typename,
                  nodes: [...previousResult.reviewWidget.reviewConnection.nodes, ...newNodes],
                  pageInfo,
                },
              },
            }
          : previousResult;
      },
    });

  return { reviews: data?.reviewWidget.reviewConnection.nodes, onLoadMore, loading };
};

export default useReviewConnection;
